import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResetPasswordPageComponent} from './pages/reset-password-page/reset-password-page.component';
import {ResetPasswordFormComponent} from './components/reset-password-form/reset-password-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [ResetPasswordPageComponent, ResetPasswordFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ]
})
export class ResetPasswordModule {
}
